import { Component, EventEmitter, Output, inject, Input } from '@angular/core';
import { FilterFromRetrievedFilesService } from '../../../services/doc-module-service/search-service/search-service';
import {uploadedFilesService} from '../../../services/doc-module-service/retrieval-service/retrieval-service'
import { uploadedFiles as UploadedFile } from '../../../app/models/file-upload.models';

@Component({
  selector: 'app-my-files',
  templateUrl: './my-files.component.html',
  styleUrls: ['./my-files.component.css']
})
export class MyFilesComponent {
  @Input() isLoading: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() uploadLocalFiles = new EventEmitter<void>();
  @Output() selectExistingFiles = new EventEmitter<UploadedFile[]>();
  @Output() deselectExistingFile = new EventEmitter<UploadedFile>();
  retrievedFiles: UploadedFile[] = []
  private readonly filterFromRetrievedFilesService = inject(FilterFromRetrievedFilesService);
  private readonly uploadedFilesService = inject(uploadedFilesService)


  onUploadLocalFilesClick() {
    this.uploadLocalFiles.emit();
  }

  onSearch(value: string) {
    const trimmed = value?.trim();
    console.log(trimmed);
    if (!trimmed) {
      this.uploadedFilesService.getUploadedFiles().subscribe({next:(response)=>{
       const records = (response?.data?.records as unknown as UploadedFile[]) || [];
          if (response?.code === 200) {
            this.retrievedFiles = records;
          } else if (records.length) {
            this.retrievedFiles = [...this.retrievedFiles, ...records];
          }
        },
        error: (err) => {
          console.error('Failed to filter retrieved files', err);
        }
      });
    }
    this.filterFromRetrievedFilesService
      .FilterFromRetrievedFiles(trimmed)
      .subscribe({
        next: (response) => {
          const records = (response?.data?.records as unknown as UploadedFile[]) || [];
          if (response?.code === 200) {
            this.retrievedFiles = records;
          } else if (records.length) {
            this.retrievedFiles = [...this.retrievedFiles, ...records];
          }
        },
        error: (err) => {
          console.error('Failed to filter retrieved files', err);
        }
      });
  }

  getFilePrefix(file: string): string {
    const extension = file?.split('.').pop()?.toLowerCase();
    if (!extension) {
      return '';
    }
    if (extension === 'pdf') {
      return '../../assets/icons/pdf-icon.svg ';
    }
    if (extension === 'docx') {
      return '../../assets/icons/word-icon.svg ';
    }
    if (extension === 'txt') {
      return '../../assets/icons/text.svg';
    }
    return '';
  }

  onCheckboxChange(file: UploadedFile, event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;
    if (input.checked) {
      this.selectExistingFiles.emit([file]);
    } else {
      this.deselectExistingFile.emit(file);
    }
  }

  fileUploadDuration(timestampStr: string, nowMs: number = Date.now()): string {
    const trimmed = timestampStr.trim();
  
    // Parse as number if possible; fall back to Date.parse for ISO strings
    const numeric = Number(trimmed);
    const tsMs = Number.isFinite(numeric)
      ? (numeric < 1e12 ? numeric * 1000 : numeric) // allow seconds or milliseconds
      : Date.parse(trimmed);
  
    if (!Number.isFinite(tsMs)) {
      throw new Error('Invalid timestamp string');
    }
    const msPerMinute = 60 * 1000;
    const msPerHour = 60 * 60 * 1000;
    const msPerDay = 24 * msPerHour;
    const msPerYear = 365 * msPerDay;
  
    const diff = Math.max(0, nowMs - tsMs);
  
    if (diff < msPerMinute) {
      return 'less than a minute';
    }
    if (diff < msPerHour) {
      const minutes = Math.floor(diff / msPerMinute);
      return `${minutes} minute${minutes === 1 ? '' : 's'}`;
    }
    if (diff < msPerDay) {
      const hours = Math.floor(diff / msPerHour);
      return `${hours} hour${hours === 1 ? '' : 's'}`;
    }
    if (diff < msPerYear) {
      const days = Math.floor(diff / msPerDay);
      return `${days} day${days === 1 ? '' : 's'}`;
    }
  
    const years = Math.floor(diff / msPerYear);
    return `${years} year${years === 1 ? '' : 's'}`;
  }
}
